module.exports = __webpack_public_path__ + "media/images/flags/mu-97beced41b168e88e8fb1d9562264d1d.svg";